export default __webpack_public_path__ + "img/74b4c9ab2c9a0297c717ddca77d60ad3.svg";